import { DAYS, YEARS } from "../const/time";
export class DateHelper {
  public static get currentDate() {
    return new Date();
  }

  public static get currentDateIgnoreTime() {
    return this.ignoreTime(this.currentDate)
  }

  public static SubstractDaysFromDate(date: Date, daysToSubtract: number) {
    const newDate = new Date(date.getTime() - daysToSubtract * DAYS);
    return newDate;
  }

  public static AddDaysFromDate(date: Date, daysToAdd: number) {
    const newDate = new Date(date.getTime() + daysToAdd * DAYS);
    return newDate;
  }

  public static yearsAgo(date: Date, numberOfYears: number) {
    return new Date(date.getTime() - (numberOfYears * YEARS));
  }

  public static ignoreTime(date: Date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
  }

}
